export enum PurchaseTypes {
  BOOST = "boost",
  POINTS = "points"
}
